var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthLayoutFull',{attrs:{"center":""}},[_c('PackagePlanBoxes',{attrs:{"slot":"content"},slot:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }